<script setup lang="ts">
import type { LocationApiSearchResult } from '@@/shared/location/types';

const props = defineProps<{
  location: LocationApiSearchResult
}>();

const agentSectorLink = computed(() => {
  return {
    name: 'find-real-estate-agent-agentSector',
    params: {
      agentSector: props.location.slug,
    },
  };
});
</script>

<template>
  <div class="bg-secondary rounded-2xl text-white p-l flex flex-col items-center gap-m">
    <IadTitle :text="$t('agent.search_form.breadcrumb.agent_sector', { location: props.location.displayName })" />
    <IadBtn
      size="large"
      :text="$t('core.navigation.find_agent')"
      :to="agentSectorLink"
      class="self-center"
    />
  </div>
</template>
